var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _g2, _path14, _g3, _path15, _g4, _path16, _g5, _path17, _g6, _path18, _g7, _path19, _g8, _path20, _g9, _path21, _g10, _path22, _path23, _path24, _path25, _path26, _path27, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStairs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1007,
    viewBox: "0 0 1920 1007",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1539.91 175.701V197.361C1537.12 196.469 1534.78 194.534 1533.38 191.961V191.892C1533.22 191.593 1533.07 191.286 1532.94 190.972C1532.94 190.972 1532.94 190.972 1532.94 190.972C1532.51 189.933 1532.23 188.837 1532.12 187.718C1532.11 187.642 1532.11 187.566 1532.12 187.49C1532.12 187.184 1532.12 186.877 1532.12 186.571V186.472C1532.12 185.767 1532.2 185.065 1532.35 184.375C1532.39 184.107 1532.44 183.843 1532.52 183.584C1532.52 183.425 1532.61 183.267 1532.66 183.109C1532.77 182.773 1532.89 182.443 1533.03 182.12C1533.17 181.781 1533.33 181.451 1533.5 181.131C1534.87 178.569 1537.16 176.626 1539.91 175.701Z",
    fill: "#6DA3CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1539.91 175.701V181.091H1532C1533.89 178.39 1536.71 176.473 1539.91 175.701V175.701Z",
    fill: "#203B70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1536.09 187.52C1536.09 189.982 1534.96 191.97 1533.55 191.97H1533.36V191.901C1533.2 191.602 1533.05 191.295 1532.92 190.981C1532.92 190.981 1532.92 190.981 1532.92 190.981C1532.49 189.943 1532.21 188.846 1532.1 187.727C1532.09 187.652 1532.09 187.576 1532.1 187.5C1532.1 187.193 1532.1 186.887 1532.1 186.58V186.481C1532.1 185.776 1532.18 185.074 1532.33 184.384C1532.37 184.117 1532.43 183.852 1532.5 183.593C1532.81 183.297 1533.22 183.127 1533.65 183.118C1534.96 183.069 1536.09 185.057 1536.09 187.52Z",
    fill: "#E5DFBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1534.97 187.52C1534.97 189.428 1534.08 190.981 1532.99 190.981H1532.9C1532.47 189.943 1532.19 188.846 1532.08 187.727C1532.07 187.652 1532.07 187.575 1532.08 187.5C1532.08 187.193 1532.08 186.887 1532.08 186.58V186.481C1532.08 185.776 1532.16 185.074 1532.31 184.384C1532.52 184.207 1532.79 184.109 1533.07 184.107C1534.08 184.058 1534.97 185.611 1534.97 187.52Z",
    fill: "#F2EBCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1991.9 51.8729V92.1367C1991.9 93.7588 1991.9 95.361 1991.77 96.9237C1991.77 97.982 1991.65 99.0204 1991.56 100.039C1990.33 113.886 1985.98 124.617 1980.51 127.129L1979.7 127.426L1623.64 256.99H1623.51C1621.32 257.755 1619 258.091 1616.68 257.979V257.979C1615.19 257.92 1613.71 257.84 1612.25 257.732C1611.51 257.682 1610.78 257.623 1610.04 257.554C1609.31 257.484 1608.57 257.425 1607.84 257.346L1605.56 257.237C1604.69 257.128 1603.83 257.02 1602.97 256.891L1601.29 256.644L1599.09 256.278L1597.65 256.021C1596.76 255.852 1595.88 255.684 1595.01 255.496C1594.35 255.358 1593.69 255.219 1593.03 255.061L1591.19 254.636C1584.38 253 1577.76 250.681 1571.41 247.713C1571.06 247.554 1570.71 247.386 1570.35 247.208L1569.18 246.625C1568.64 246.354 1568.1 246.077 1567.57 245.794C1567.04 245.507 1566.53 245.23 1566 244.933C1565.48 244.637 1565.01 244.35 1564.48 244.053C1564.15 243.865 1563.84 243.668 1563.49 243.47C1561.88 242.481 1560.34 241.492 1558.87 240.414C1558.52 240.166 1558.19 239.919 1557.88 239.662L1557.41 239.306L1557.27 239.197C1550.2 233.747 1544.97 227.329 1542.2 220.405C1541.62 218.968 1541.14 217.49 1540.77 215.984L1562.2 208.181H1562.31L1967.74 60.6655H1967.84L1991.9 51.8729Z",
    fill: "url(#paint0_linear_658_163)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1991.9 51.8729V56.8181L1542.27 220.484C1541.69 219.043 1541.21 217.563 1540.84 216.054L1991.9 51.8729Z",
    fill: "url(#paint1_linear_658_163)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1991.9 -39.9596V51.8727L1540.8 216.053C1540.72 215.757 1540.65 215.46 1540.59 215.163C1540.54 214.906 1540.49 214.659 1540.45 214.402C1540.41 214.145 1540.36 213.937 1540.32 213.699C1540.19 212.921 1540.09 212.13 1540.02 211.326C1540.02 211.296 1540.02 211.266 1540.02 211.237V211.237C1540.02 210.851 1539.95 210.455 1539.94 210.07C1539.93 209.684 1539.94 209.229 1539.94 208.804V76.9944L1860.55 -39.7123L1861.28 -39.9794L1991.9 -39.9596Z",
    fill: "#F1F5F4/*url(#paint2_linear_658_163)*/"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1991.9 43.4658V51.8727L1540.8 216.053C1540.72 215.757 1540.65 215.46 1540.59 215.163C1540.54 214.906 1540.49 214.659 1540.45 214.402C1540.41 214.144 1540.36 213.937 1540.32 213.699C1540.18 212.908 1540.09 212.127 1540.02 211.326C1540.01 211.287 1540.01 211.246 1540.02 211.207C1540.02 210.821 1539.95 210.426 1539.94 210.04C1539.93 209.654 1539.94 209.199 1539.94 208.774V207.963L1991.9 43.4658Z",
    fill: "#1665A8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1991.9 -39.9595V-37.3781H1865.49C1863.13 -37.3712 1860.79 -36.9563 1858.57 -36.1517L1856.31 -35.3407L1539.93 79.388V77.034L1860.54 -39.6727C1861.6 -39.8507 1862.68 -39.94 1863.75 -39.9397L1991.9 -39.9595Z",
    fill: "#1665A8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1991.9 -39.4648H1862.22C1861.71 -39.4653 1861.2 -39.3748 1860.72 -39.1977L1855.97 -37.4867L1686.96 23.5173L1545.85 74.8386L1539.91 76.9947V65.1262L1542.82 64.0679L1545.79 62.9701L1855.79 -49.8497L1857.98 -50.6409C1860.13 -51.4235 1862.41 -51.8251 1864.7 -51.8278H1991.9H1997.84V-51.3036C1997.84 -50.6161 1997.8 -49.9292 1997.72 -49.2464C1997.19 -44.6869 1994.92 -40.9681 1991.9 -39.4648ZM1539.91 76.9253V65.1261L1533.98 67.2822V67.3515C1533.97 68.2059 1534.06 69.0581 1534.24 69.8933C1534.97 73.3351 1537.15 76.0451 1539.91 76.9253Z",
    fill: "url(#paint3_linear_658_163)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1997.84 -51.828V-49.2466H1866.48C1864.12 -49.2397 1861.78 -48.8248 1859.56 -48.0202L1857.29 -47.2092L1539.91 67.8359L1537.14 68.825L1534.24 69.8733C1534.06 69.0381 1533.97 68.1859 1533.98 67.3315V67.2623L1539.91 65.1062L1542.82 64.0677L1545.79 62.9698L1855.79 -49.8499L1857.98 -50.6412C1860.13 -51.4237 1862.41 -51.8253 1864.7 -51.828H1997.84Z",
    fill: "#1693D3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_658_163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1585,
    y: 103,
    width: 26,
    height: 52
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1590.52 154.11H1605.4C1608.13 154.11 1610.34 151.896 1610.34 149.165V108.96C1610.34 106.229 1608.13 104.015 1605.4 104.015H1590.52C1587.79 104.015 1585.58 106.229 1585.58 108.96V149.165C1585.58 151.896 1587.79 154.11 1590.52 154.11Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_658_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1590.53 154.111H1605.4C1608.13 154.111 1610.35 151.897 1610.35 149.166V108.961C1610.35 106.23 1608.13 104.016 1605.4 104.016H1590.53C1587.8 104.016 1585.58 106.23 1585.58 108.961V149.166C1585.58 151.897 1587.8 154.111 1590.53 154.111Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1573.1 240.433H1560.25L1617.48 83.1759H1630.34L1573.1 240.433Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1592.74 236.73H1579.88L1637.12 79.4728H1649.98L1592.74 236.73Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.4 104.005H1590.56C1589.73 104.008 1588.91 104.221 1588.18 104.624C1587.46 105.026 1586.84 105.606 1586.4 106.31C1585.89 107.096 1585.62 108.013 1585.62 108.95V149.125C1585.62 150.437 1586.14 151.695 1587.06 152.622C1587.99 153.549 1589.25 154.07 1590.56 154.07H1605.4C1606.71 154.07 1607.97 153.549 1608.89 152.622C1609.82 151.695 1610.34 150.437 1610.34 149.125V108.95C1610.34 107.639 1609.82 106.381 1608.89 105.454C1607.97 104.526 1606.71 104.005 1605.4 104.005V104.005Z",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_658_163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1550,
    y: 103,
    width: 27,
    height: 52
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1556.12 154.11H1571C1573.73 154.11 1575.94 151.896 1575.94 149.165V108.96C1575.94 106.229 1573.73 104.015 1571 104.015H1556.12C1553.39 104.015 1551.17 106.229 1551.17 108.96V149.165C1551.17 151.896 1553.39 154.11 1556.12 154.11Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_658_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1556.12 154.111H1571C1573.73 154.111 1575.94 151.897 1575.94 149.166V108.961C1575.94 106.23 1573.73 104.016 1571 104.016H1556.12C1553.39 104.016 1551.18 106.23 1551.18 108.961V149.166C1551.18 151.897 1553.39 154.111 1556.12 154.111Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1529.92 237.719H1515.09L1572.68 79.473H1587.51L1529.92 237.719Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1552.35 237.719H1537.51L1595.11 79.473H1609.94L1552.35 237.719Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1571 104.005H1556.12C1553.39 104.005 1551.17 106.219 1551.17 108.95V149.155C1551.17 151.886 1553.39 154.1 1556.12 154.1H1571C1573.73 154.1 1575.94 151.886 1575.94 149.155V108.95C1575.94 106.219 1573.73 104.005 1571 104.005Z",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_658_163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1666,
    y: 75,
    width: 27,
    height: 52
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1686.77 76.3313H1671.9C1669.17 76.3313 1666.95 78.5453 1666.95 81.2765V121.481C1666.95 124.212 1669.17 126.426 1671.9 126.426H1686.77C1689.5 126.426 1691.72 124.212 1691.72 121.481V81.2765C1691.72 78.5453 1689.5 76.3313 1686.77 76.3313Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_658_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1686.77 76.3313H1671.9C1669.17 76.3313 1666.95 78.5453 1666.95 81.2765V121.481C1666.95 124.212 1669.17 126.426 1671.9 126.426H1686.77C1689.5 126.426 1691.72 124.212 1691.72 121.481V81.2765C1691.72 78.5453 1689.5 76.3313 1686.77 76.3313Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653.04 193.948H1638.2L1695.8 35.7014H1710.64L1653.04 193.948Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1676.95 193.948H1662.12L1719.72 35.7014H1734.56L1676.95 193.948Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1688.02 76.4992C1687.61 76.3873 1687.19 76.3308 1686.77 76.3311H1671.94C1670.63 76.3311 1669.37 76.8521 1668.44 77.7795C1667.51 78.7069 1666.99 79.9647 1666.99 81.2763V121.491C1666.99 122.022 1667.08 122.55 1667.25 123.053C1667.58 124.038 1668.21 124.894 1669.05 125.501C1669.89 126.108 1670.9 126.435 1671.94 126.436H1686.77C1688.08 126.436 1689.34 125.915 1690.27 124.987C1691.2 124.06 1691.72 122.802 1691.72 121.491V81.2763C1691.72 80.1831 1691.35 79.1215 1690.68 78.2572C1690.01 77.3929 1689.08 76.7747 1688.02 76.4992V76.4992Z",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_658_163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1633,
    y: 75,
    width: 27,
    height: 52
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1653.57 76.3313H1638.7C1635.96 76.3313 1633.75 78.5453 1633.75 81.2765V121.481C1633.75 124.212 1635.96 126.426 1638.7 126.426H1653.57C1656.3 126.426 1658.52 124.212 1658.52 121.481V81.2765C1658.52 78.5453 1656.3 76.3313 1653.57 76.3313Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_658_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1653.57 76.3313H1638.7C1635.96 76.3313 1633.75 78.5453 1633.75 81.2765V121.481C1633.75 124.212 1635.96 126.426 1638.7 126.426H1653.57C1656.3 126.426 1658.52 124.212 1658.52 121.481V81.2765C1658.52 78.5453 1656.3 76.3313 1653.57 76.3313Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1602.28 227.575H1584.48L1641.71 70.3179H1659.52L1602.28 227.575Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1632.57 227.575H1614.77L1672.01 70.3179H1689.81L1632.57 227.575Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653.57 76.3313H1638.7C1635.96 76.3313 1633.75 78.5453 1633.75 81.2765V121.481C1633.75 124.212 1635.96 126.426 1638.7 126.426H1653.57C1656.3 126.426 1658.52 124.212 1658.52 121.481V81.2765C1658.52 78.5453 1656.3 76.3313 1653.57 76.3313Z",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_658_163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1699,
    y: 75,
    width: 27,
    height: 52
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1720.24 76.3318H1705.37C1702.64 76.3318 1700.42 78.5458 1700.42 81.277V121.481C1700.42 124.213 1702.64 126.427 1705.37 126.427H1720.24C1722.97 126.427 1725.19 124.213 1725.19 121.481V81.277C1725.19 78.5458 1722.97 76.3318 1720.24 76.3318Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_658_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1720.24 76.3318H1705.37C1702.64 76.3318 1700.42 78.5458 1700.42 81.277V121.481C1700.42 124.213 1702.64 126.427 1705.37 126.427H1720.24C1722.97 126.427 1725.19 124.213 1725.19 121.481V81.277C1725.19 78.5458 1722.97 76.3318 1720.24 76.3318Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.59 392.063H1603.27L1789.6 -119.893H1808.93L1622.59 392.063Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650.29 392.063H1630.97L1817.3 -119.893H1836.63L1650.29 392.063Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720.24 76.3318H1705.41C1704.1 76.3318 1702.84 76.8528 1701.91 77.7802C1700.98 78.7076 1700.46 79.9654 1700.46 81.277V121.491C1700.47 122.666 1700.89 123.802 1701.65 124.696C1702.41 125.589 1703.47 126.182 1704.63 126.367C1704.89 126.415 1705.15 126.438 1705.41 126.437H1720.24C1720.64 126.438 1721.03 126.388 1721.41 126.288C1722.49 126.027 1723.44 125.412 1724.13 124.543C1724.81 123.673 1725.19 122.598 1725.19 121.491V81.277C1725.19 79.9654 1724.67 78.7076 1723.74 77.7802C1722.81 76.8528 1721.56 76.3318 1720.24 76.3318V76.3318Z",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_658_163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1734,
    y: 75,
    width: 27,
    height: 52
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1754.64 76.3318H1739.77C1737.03 76.3318 1734.82 78.5458 1734.82 81.277V121.481C1734.82 124.213 1737.03 126.427 1739.77 126.427H1754.64C1757.37 126.427 1759.59 124.213 1759.59 121.481V81.277C1759.59 78.5458 1757.37 76.3318 1754.64 76.3318Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_658_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1754.64 76.3318H1739.77C1737.03 76.3318 1734.82 78.5458 1734.82 81.277V121.481C1734.82 124.213 1737.03 126.427 1739.77 126.427H1754.64C1757.37 126.427 1759.59 124.213 1759.59 121.481V81.277C1759.59 78.5458 1757.37 76.3318 1754.64 76.3318Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1718.98 220.652H1703.16L1760.39 63.395H1776.22L1718.98 220.652Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745.23 220.652H1729.4L1786.64 63.395H1802.46L1745.23 220.652Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.64 76.3318H1739.77C1737.03 76.3318 1734.82 78.5458 1734.82 81.277V121.481C1734.82 124.213 1737.03 126.427 1739.77 126.427H1754.64C1757.37 126.427 1759.59 124.213 1759.59 121.481V81.277C1759.59 78.5458 1757.37 76.3318 1754.64 76.3318Z",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_658_163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1806,
    y: 9,
    width: 27,
    height: 52
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1826.82 10.0361H1811.95C1809.22 10.0361 1807 12.2502 1807 14.9813V55.1858C1807 57.917 1809.22 60.131 1811.95 60.131H1826.82C1829.55 60.131 1831.77 57.917 1831.77 55.1858V14.9813C1831.77 12.2502 1829.55 10.0361 1826.82 10.0361Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_658_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1826.82 10.0361H1811.95C1809.22 10.0361 1807 12.2502 1807 14.9813V55.1858C1807 57.917 1809.22 60.131 1811.95 60.131H1826.82C1829.55 60.131 1831.77 57.917 1831.77 55.1858V14.9813C1831.77 12.2502 1829.55 10.0361 1826.82 10.0361Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.88 176.037H1771.72L1842.2 -17.6073H1860.36L1789.88 176.037Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1817.34 176.037H1799.18L1869.66 -17.6073H1887.82L1817.34 176.037Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1813.6 176.037H1795.45L1865.92 -17.6073H1884.08L1813.6 176.037Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1826.82 10.0362H1811.99C1810.67 10.0362 1809.42 10.5572 1808.49 11.4846C1807.56 12.412 1807.04 13.6698 1807.04 14.9814V55.1661C1807.04 56.454 1807.54 57.6913 1808.44 58.6148C1809.34 59.5383 1810.56 60.0752 1811.85 60.1113H1826.86C1828.17 60.1113 1829.43 59.5903 1830.36 58.6628C1831.29 57.7354 1831.81 56.4776 1831.81 55.1661V14.9814C1831.81 14.3286 1831.68 13.6823 1831.43 13.0797C1831.18 12.4772 1830.81 11.9303 1830.34 11.4705C1829.88 11.0108 1829.33 10.6474 1828.73 10.4012C1828.12 10.155 1827.47 10.0309 1826.82 10.0362V10.0362Z",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_658_163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1773,
    y: 9,
    width: 27,
    height: 52
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1793.62 10.0361H1778.74C1776.01 10.0361 1773.8 12.2502 1773.8 14.9813V55.1858C1773.8 57.917 1776.01 60.131 1778.74 60.131H1793.62C1796.35 60.131 1798.56 57.917 1798.56 55.1858V14.9813C1798.56 12.2502 1796.35 10.0361 1793.62 10.0361Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_658_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1793.62 10.0361H1778.74C1776.01 10.0361 1773.8 12.2502 1773.8 14.9813V55.1858C1773.8 57.917 1776.01 60.131 1778.74 60.131H1793.62C1796.35 60.131 1798.56 57.917 1798.56 55.1858V14.9813C1798.56 12.2502 1796.35 10.0361 1793.62 10.0361Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.66 83.1758H1762.82L1820.42 -75.0706H1835.26L1777.66 83.1758Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1801.56 83.1758H1786.72L1844.33 -75.0706H1859.16L1801.56 83.1758Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1793.62 10.0361H1778.74C1776.01 10.0361 1773.8 12.2502 1773.8 14.9813V55.1858C1773.8 57.917 1776.01 60.131 1778.74 60.131H1793.62C1796.35 60.131 1798.56 57.917 1798.56 55.1858V14.9813C1798.56 12.2502 1796.35 10.0361 1793.62 10.0361Z",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_658_163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1839,
    y: 9,
    width: 27,
    height: 52
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1860.29 10.0363H1845.42C1842.68 10.0363 1840.47 12.2503 1840.47 14.9815V55.1859C1840.47 57.9171 1842.68 60.1311 1845.42 60.1311H1860.29C1863.02 60.1311 1865.24 57.9171 1865.24 55.1859V14.9815C1865.24 12.2503 1863.02 10.0363 1860.29 10.0363Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_658_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1860.29 10.0363H1845.42C1842.68 10.0363 1840.47 12.2503 1840.47 14.9815V55.1859C1840.47 57.9171 1842.68 60.1311 1845.42 60.1311H1860.29C1863.02 60.1311 1865.24 57.9171 1865.24 55.1859V14.9815C1865.24 12.2503 1863.02 10.0363 1860.29 10.0363Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1821.17 139.551H1806.34L1863.94 -18.6953H1878.78L1821.17 139.551Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1848.91 139.551H1834.07L1891.67 -18.6953H1906.51L1848.91 139.551Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860.29 10.0363H1845.42C1842.68 10.0363 1840.47 12.2503 1840.47 14.9815V55.1859C1840.47 57.9171 1842.68 60.1311 1845.42 60.1311H1860.29C1863.02 60.1311 1865.24 57.9171 1865.24 55.1859V14.9815C1865.24 12.2503 1863.02 10.0363 1860.29 10.0363Z",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_658_163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1874,
    y: 9,
    width: 27,
    height: 52
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1894.69 10.0364H1879.81C1877.08 10.0364 1874.87 12.2504 1874.87 14.9816V55.1861C1874.87 57.9172 1877.08 60.1313 1879.81 60.1313H1894.69C1897.42 60.1313 1899.63 57.9172 1899.63 55.1861V14.9816C1899.63 12.2504 1897.42 10.0364 1894.69 10.0364Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_658_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1894.69 10.0364H1879.81C1877.08 10.0364 1874.87 12.2504 1874.87 14.9816V55.1861C1874.87 57.9172 1877.08 60.1313 1879.81 60.1313H1894.69C1897.42 60.1313 1899.63 57.9172 1899.63 55.1861V14.9816C1899.63 12.2504 1897.42 10.0364 1894.69 10.0364Z",
    fill: "#52BEDB",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1867.66 122.737H1852.82L1910.42 -35.5089H1925.26L1867.66 122.737Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1891.27 122.737H1876.44L1934.04 -35.5089H1948.87L1891.27 122.737Z",
    fill: "#92DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1894.69 10.0364H1879.81C1877.08 10.0364 1874.87 12.2504 1874.87 14.9816V55.1861C1874.87 57.9172 1877.08 60.1313 1879.81 60.1313H1894.69C1897.42 60.1313 1899.63 57.9172 1899.63 55.1861V14.9816C1899.63 12.2504 1897.42 10.0364 1894.69 10.0364Z",
    stroke: "#12223D",
    strokeMiterlimit: 10
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1667.82 70.5754H1696.34V188.024H1667.82C1666.5 188.024 1665.25 187.503 1664.32 186.576C1663.39 185.648 1662.87 184.39 1662.87 183.079V75.5206C1662.87 74.2091 1663.39 72.9513 1664.32 72.0239C1665.25 71.0964 1666.5 70.5754 1667.82 70.5754V70.5754Z",
    stroke: "#12223D",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1696.34 70.5754H1724.86C1726.17 70.5754 1727.43 71.0964 1728.36 72.0239C1729.29 72.9513 1729.81 74.2091 1729.81 75.5206V183.079C1729.81 184.39 1729.29 185.648 1728.36 186.576C1727.43 187.503 1726.17 188.024 1724.86 188.024H1696.34V70.5754Z",
    stroke: "#12223D",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1807.86 4.28052H1836.39V121.729H1807.86C1806.55 121.729 1805.29 121.208 1804.37 120.281C1803.44 119.353 1802.92 118.095 1802.92 116.784V9.22572C1802.92 7.91417 1803.44 6.65633 1804.37 5.72893C1805.29 4.80152 1806.55 4.28052 1807.86 4.28052V4.28052Z",
    stroke: "#12223D",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1836.39 4.28052H1864.91C1865.56 4.28052 1866.2 4.40843 1866.8 4.65695C1867.4 4.90547 1867.95 5.26972 1868.41 5.72893C1868.87 6.18813 1869.23 6.73329 1869.48 7.33327C1869.73 7.93325 1869.86 8.5763 1869.86 9.22572V116.784C1869.86 118.095 1869.33 119.353 1868.41 120.281C1867.48 121.208 1866.22 121.729 1864.91 121.729H1836.39V4.28052Z",
    stroke: "#12223D",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1947.44 -26.6471H1923.87C1921.13 -26.6471 1918.92 -24.4331 1918.92 -21.7019V85.8562C1918.92 88.5873 1921.13 90.8014 1923.87 90.8014H1947.44C1950.18 90.8014 1952.39 88.5873 1952.39 85.8562V-21.7019C1952.39 -24.4331 1950.18 -26.6471 1947.44 -26.6471Z",
    stroke: "#12223D",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1585.91 215.698H1609.49C1612.22 215.698 1614.44 213.483 1614.44 210.752V103.194C1614.44 100.463 1612.22 98.2491 1609.49 98.2491H1585.91C1583.18 98.2491 1580.97 100.463 1580.97 103.194V210.752C1580.97 213.483 1583.18 215.698 1585.91 215.698Z",
    stroke: "#12223D",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.519531,
    y: 855.692,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 -0.519531 855.692)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 911.505,
    y: 519.698,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 911.505 519.698)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 455.511,
    y: 689.195,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 455.511 689.195)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1367.54,
    y: 353.2,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 1367.54 353.2)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 231.525,
    y: 774.895,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 231.525 774.895)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1143.55,
    y: 438.9,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 1143.55 438.9)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 687.556,
    y: 608.398,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 687.556 608.398)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1599.58,
    y: 272.403,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 1599.58 272.403)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1738,
    y: 829.744,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 78.1738 829.744)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 990.198,
    y: 493.749,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 990.198 493.749)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 534.204,
    y: 663.246,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 534.204 663.246)",
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.23,
    y: 327.251,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 1446.23 327.251)",
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 306.183,
    y: 745.995,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 306.183 745.995)",
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1218.21,
    y: 410,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 1218.21 410)",
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 762.213,
    y: 579.498,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 762.213 579.498)",
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1674.24,
    y: 243.503,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 1674.24 243.503)",
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 156.892,
    y: 805.795,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 156.892 805.795)",
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1068.92,
    y: 469.8,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 1068.92 469.8)",
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 612.922,
    y: 639.298,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 612.922 639.298)",
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1524.95,
    y: 303.303,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 1524.95 303.303)",
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 380.853,
    y: 718.095,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 380.853 718.095)",
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 1292.88,
    y: 382.1,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 1292.88 382.1)",
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 836.883,
    y: 551.597,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 836.883 551.597)",
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1748.91,
    y: 215.602,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 1748.91 215.602)",
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 1823.53,
    y: 183.703,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 1823.53 183.703)",
    fill: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 1898.19,
    y: 154.802,
    width: 75,
    height: 25,
    rx: 5,
    transform: "rotate(-0.689221 1898.19 154.802)",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "stairs-draw__line",
    x1: -35.1634,
    y1: 865.311,
    x2: 1946.57,
    y2: 144.02,
    stroke: "white",
    strokeWidth: 20
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "stairs-draw__line2",
    x1: -46.8551,
    y1: 802.941,
    x2: 1934.87,
    y2: 81.6507,
    stroke: "white",
    strokeWidth: 5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1900.5,
    y1: 92,
    x2: 1900.5,
    y2: 151,
    stroke: "white",
    strokeWidth: 5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 716.5,
    y1: 526,
    x2: 716.5,
    y2: 585,
    stroke: "white",
    strokeWidth: 5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1308.5,
    y1: 309,
    x2: 1308.5,
    y2: 368,
    stroke: "white",
    strokeWidth: 5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 124.5,
    y1: 743,
    x2: 124.5,
    y2: 802,
    stroke: "white",
    strokeWidth: 5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 1604.5,
    y1: 200,
    x2: 1604.5,
    y2: 259,
    stroke: "white",
    strokeWidth: 5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 420.5,
    y1: 634,
    x2: 420.5,
    y2: 693,
    stroke: "white",
    strokeWidth: 5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 1012.5,
    y1: 417,
    x2: 1012.5,
    y2: 476,
    stroke: "white",
    strokeWidth: 5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 1752.5,
    y1: 146,
    x2: 1752.5,
    y2: 205,
    stroke: "white",
    strokeWidth: 5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 568.5,
    y1: 580,
    x2: 568.5,
    y2: 639,
    stroke: "white",
    strokeWidth: 5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 1160.5,
    y1: 363,
    x2: 1160.5,
    y2: 422,
    stroke: "white",
    strokeWidth: 5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 1456.5,
    y1: 254,
    x2: 1456.5,
    y2: 313,
    stroke: "white",
    strokeWidth: 5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 272.5,
    y1: 688,
    x2: 272.5,
    y2: 747,
    stroke: "white",
    strokeWidth: 5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 864.5,
    y1: 471,
    x2: 864.5,
    y2: 530,
    stroke: "white",
    strokeWidth: 5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 1826.5,
    y1: 120,
    x2: 1826.5,
    y2: 179,
    stroke: "white",
    strokeWidth: 5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 642.5,
    y1: 554,
    x2: 642.5,
    y2: 613,
    stroke: "white",
    strokeWidth: 5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 1234.5,
    y1: 337,
    x2: 1234.5,
    y2: 396,
    stroke: "white",
    strokeWidth: 5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 50.5,
    y1: 771,
    x2: 50.5,
    y2: 830,
    stroke: "white",
    strokeWidth: 5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 1530.5,
    y1: 228,
    x2: 1530.5,
    y2: 287,
    stroke: "white",
    strokeWidth: 5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 346.5,
    y1: 662,
    x2: 346.5,
    y2: 721,
    stroke: "white",
    strokeWidth: 5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 938.5,
    y1: 445,
    x2: 938.5,
    y2: 504,
    stroke: "white",
    strokeWidth: 5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 1678.5,
    y1: 174,
    x2: 1678.5,
    y2: 233,
    stroke: "white",
    strokeWidth: 5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 494.5,
    y1: 608,
    x2: 494.5,
    y2: 667,
    stroke: "white",
    strokeWidth: 5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 1086.5,
    y1: 391,
    x2: 1086.5,
    y2: 450,
    stroke: "white",
    strokeWidth: 5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 1382.5,
    y1: 282,
    x2: 1382.5,
    y2: 341,
    stroke: "white",
    strokeWidth: 5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 198.5,
    y1: 716,
    x2: 198.5,
    y2: 775,
    stroke: "white",
    strokeWidth: 5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 790.5,
    y1: 499,
    x2: 790.5,
    y2: 558,
    stroke: "white",
    strokeWidth: 5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 1789.5,
    y1: 135,
    x2: 1789.5,
    y2: 194,
    stroke: "white",
    strokeWidth: 5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 605.5,
    y1: 569,
    x2: 605.5,
    y2: 628,
    stroke: "white",
    strokeWidth: 5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 1197.5,
    y1: 352,
    x2: 1197.5,
    y2: 411,
    stroke: "white",
    strokeWidth: 5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 786,
    x2: 13.5,
    y2: 845,
    stroke: "white",
    strokeWidth: 5
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 1493.5,
    y1: 243,
    x2: 1493.5,
    y2: 302,
    stroke: "white",
    strokeWidth: 5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 309.5,
    y1: 677,
    x2: 309.5,
    y2: 736,
    stroke: "white",
    strokeWidth: 5
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 901.5,
    y1: 460,
    x2: 901.5,
    y2: 519,
    stroke: "white",
    strokeWidth: 5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 1641.5,
    y1: 189,
    x2: 1641.5,
    y2: 248,
    stroke: "white",
    strokeWidth: 5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 457.5,
    y1: 623,
    x2: 457.5,
    y2: 682,
    stroke: "white",
    strokeWidth: 5
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 1049.5,
    y1: 406,
    x2: 1049.5,
    y2: 465,
    stroke: "white",
    strokeWidth: 5
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 1345.5,
    y1: 297,
    x2: 1345.5,
    y2: 356,
    stroke: "white",
    strokeWidth: 5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 161.5,
    y1: 731,
    x2: 161.5,
    y2: 790,
    stroke: "white",
    strokeWidth: 5
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 753.5,
    y1: 514,
    x2: 753.5,
    y2: 573,
    stroke: "white",
    strokeWidth: 5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 1863.5,
    y1: 107,
    x2: 1863.5,
    y2: 166,
    stroke: "white",
    strokeWidth: 5
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 679.5,
    y1: 541,
    x2: 679.5,
    y2: 600,
    stroke: "white",
    strokeWidth: 5
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 1271.5,
    y1: 324,
    x2: 1271.5,
    y2: 383,
    stroke: "white",
    strokeWidth: 5
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 87.5,
    y1: 758,
    x2: 87.5,
    y2: 817,
    stroke: "white",
    strokeWidth: 5
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 1567.5,
    y1: 215,
    x2: 1567.5,
    y2: 274,
    stroke: "white",
    strokeWidth: 5
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 383.5,
    y1: 649,
    x2: 383.5,
    y2: 708,
    stroke: "white",
    strokeWidth: 5
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 975.5,
    y1: 432,
    x2: 975.5,
    y2: 491,
    stroke: "white",
    strokeWidth: 5
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 1715.5,
    y1: 161,
    x2: 1715.5,
    y2: 220,
    stroke: "white",
    strokeWidth: 5
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 531.5,
    y1: 595,
    x2: 531.5,
    y2: 654,
    stroke: "white",
    strokeWidth: 5
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 1123.5,
    y1: 378,
    x2: 1123.5,
    y2: 437,
    stroke: "white",
    strokeWidth: 5
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 1419.5,
    y1: 269,
    x2: 1419.5,
    y2: 328,
    stroke: "white",
    strokeWidth: 5
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 235.5,
    y1: 703,
    x2: 235.5,
    y2: 762,
    stroke: "white",
    strokeWidth: 5
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 827.5,
    y1: 486,
    x2: 827.5,
    y2: 545,
    stroke: "white",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_658_163",
    x1: 1992.28,
    y1: 81.8705,
    x2: 1540.29,
    y2: 238.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.375691,
    stopColor: "#1693D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1665A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_658_163",
    x1: 1992.28,
    y1: 76.4108,
    x2: 1563,
    y2: 257.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.375691,
    stopColor: "#1693D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1665A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_658_163",
    x1: 1265.26,
    y1: 235.851,
    x2: 1992.32,
    y2: 3.46433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5E0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F5F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_658_163",
    x1: 1533.78,
    y1: 76.9811,
    x2: 1997.31,
    y2: -47.6235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1693D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87BCDD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairs);
export default __webpack_public_path__ + "static/media/stairs.a9135a7689c2876dda23765e9b56cdad.svg";
export { ForwardRef as ReactComponent };